module.exports = __webpack_public_path__ + "img/auth-bg.2fe742f0.png";